/**
 * Web stub for @react-native-clipboard/clipboard.
 * The expo-clipboard shim uses navigator.clipboard on web instead.
 */
export default {
  setString: (_s: string) => {},
  getString: async () => '',
};
